/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Check_OpenapiInputs */

const en_directory_agent_readiness_check_openapi = /** @type {(inputs: Directory_Agent_Readiness_Check_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI specification`)
};

const zh_directory_agent_readiness_check_openapi = /** @type {(inputs: Directory_Agent_Readiness_Check_OpenapiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OpenAPI 规范`)
};

/**
* | output |
* | --- |
* | "OpenAPI specification" |
*
* @param {Directory_Agent_Readiness_Check_OpenapiInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_check_openapi = /** @type {((inputs?: Directory_Agent_Readiness_Check_OpenapiInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Check_OpenapiInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_check_openapi(inputs)
	return zh_directory_agent_readiness_check_openapi(inputs)
});
export { directory_agent_readiness_check_openapi as "directory.agent_readiness.check.openapi" }